<template>
  <div class="holder">
    <div class="days" :style="{ transform: styleTransform }">

      <div class="day">
        <div class="slots">
          <div class="day-name">Monday</div>
          <div class="slot" v-for="index in [0, 1, 2, 3, 4]" :key="index">
            <action-card :action-object="getSlotActionObject(index)" :small="true"></action-card>
          </div>
        </div>
      </div>

      <div class="day">
        <div class="slots">
          <div class="day-name">Tuesday</div>
          <div class="slot" v-for="index in [5, 6, 7, 8, 9]" :key="index">
            <action-card :action-object="getSlotActionObject(index)" :small="true"></action-card>
          </div>
        </div>
      </div>

      <div class="day">
        <div class="slots">
          <div class="day-name">Wednesday</div>
          <div class="slot" v-for="index in [10, 11, 12, 13, 14]" :key="index">
            <action-card :action-object="getSlotActionObject(index)" :small="true"></action-card>
          </div>
        </div>
      </div>

      <div class="day">
        <div class="slots">
          <div class="day-name">Thursday</div>
          <div class="slot" v-for="index in [15, 16, 17, 18, 19]" :key="index">
            <action-card :action-object="getSlotActionObject(index)" :small="true"></action-card>
          </div>
        </div>
      </div>

      <div class="day">
        <div class="slots">
          <div class="day-name">Friday</div>
          <div class="slot" v-for="index in [20, 21, 22, 23, 24]" :key="index">
            <action-card :action-object="getSlotActionObject(index)" :small="true"></action-card>
          </div>
        </div>
      </div>

    </div>

    <div class="exam">
      <div class="exam__title">Exam</div>
      <div>
        <ActionIcon v-bind:action-object="weekExam"></ActionIcon>
      </div>
    </div>

  </div>
</template>

<script>

import { mapGetters } from "vuex";
import ActionCard from "./ActionCard";
import ActionIcon from "./ActionIcon";

export default {
  name: "ActionTimeline",
  components: { ActionCard, ActionIcon },
  computed: {
    styleTransform: function() {
      const x = (this.currentSlotWeekIndex + 1) * -8;
      return `translate(${x}vw, 0)`;
    },
    ...mapGetters(["currentSlotWeekIndex", "weekActions", "weekExam"])
  },
  methods: {
    getSlotActionObject(index) {
      return this.weekActions[index];
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$day-width: 40vw;
$day-height: $day-width / 3;
$slot-width: $day-width / 5;

.holder {
  overflow: hidden;
  position: relative;
}

.exam {
  position: absolute;
  right: 0;
  top: 0;
  width: $slot-width + 2vw;
  height: $day-height;
  background: #e23837;

  &__title {
    margin-left: 1vw;
    font-size: 2.6vw;
  }

}

.days {

  display: flex;
  width: 5 * $day-width;

  .day {
    position: relative;
    display: inline-block;
    background: #512f51;
    width: $day-width;
    height: $day-height;
    color: white;
    font-weight: bold;
    font-size: 2.6vw;
    text-align: center;

    .day-name {
      position: absolute;
      top: 0;
      left: 6px;
    }

    .slots {
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 100%;

      .slot {
        background: #432743;
        width: $slot-width - 1vw;
        margin-top: $day-height / 4;
        margin-bottom: $day-height / 20;
      }
    }
  }
}

</style>
